import { View } from "../../Core";
import Vue from "vue";

interface ITrainer {
    id: string;
    fullName: string;
    description: string;
    photoThumbUrl: string;
    profileUrl: string;
}

interface ILocation {
    id: string;
    name: string;
    trainers: Array<ITrainer>;
}

class ViewDataModel {
    locations: Array<ILocation> = new Array<ILocation>();
    locationId: string = "";
    trainerId: string = "";
}

export class PersonalTrainingView extends View<PersonalTrainingView> {
    private _viewData: ViewDataModel = window.__VIEW_DATA;

    public constructor() {
        super();
        this.SetupVue();
    }

    SetupVue() {
        let v = new Vue({
            el: ".app",
            data: {
                locationId: this._viewData.locationId,
                trainerId: this._viewData.trainerId,
                locations: this._viewData.locations
            },
            computed: {
                trainers() : Array<ITrainer> {
                    let vue = this;
                    var location = vue.locations.find(x => x.id === vue.locationId);
                    return location ? location.trainers : Array<ITrainer>();
                },
                selectedTrainer() : ITrainer {
                    let vue = this;

                    var location = vue.locations.find(x => x.id === vue.locationId);
                    var trainers = location ? location.trainers : Array<ITrainer>();

                    var trainer = trainers.find(x => x.id === vue.trainerId);
                    if (!trainer) {
                        vue.trainerId = "";
                    }

                    return trainer || {} as ITrainer;
                }
            }
        });
    }
}


// WEBPACK FOOTER //
// ./www/js/Pages/Club/PersonalTrainingView.ts